// extracted by mini-css-extract-plugin
export default {"strip":"KpiStrip_strip__Mbvdb"};